// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"c565407b","169":"a85269df","462":"cd2db864","887":"ffa9ba27"}[chunkId] + ".chunk.css";
};